var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"wrap"},[_c('div',[_c('p',{staticClass:"error-code"},[_vm._v("404")])])])}]

export { render, staticRenderFns }